export const STATUS_STYLES = {
  "In Transit": "bg-blue-100 text-blue-700 dark:bg-blue-500/15 dark:text-blue-300",
  "Delivered": "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-300",
  "Pending Pickup": "bg-slate-100 text-slate-700 dark:bg-slate-500/15 dark:text-slate-300",
  "Delayed": "bg-orange-100 text-orange-700 dark:bg-orange-500/15 dark:text-orange-300",
  "At Risk": "bg-yellow-100 text-yellow-700 dark:bg-yellow-500/15 dark:text-yellow-300",
  "Exception": "bg-red-100 text-red-700 dark:bg-red-500/15 dark:text-red-300",
  "Paid": "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-300",
  "Outstanding": "bg-orange-100 text-orange-700 dark:bg-orange-500/15 dark:text-orange-300",
  "Overdue": "bg-red-100 text-red-700 dark:bg-red-500/15 dark:text-red-300",
  "Connected": "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-300",
  "Production": "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-300",
  "Sandbox": "bg-blue-100 text-blue-700 dark:bg-blue-500/15 dark:text-blue-300",
  "Pending": "bg-slate-100 text-slate-600 dark:bg-slate-500/15 dark:text-slate-300",
};

export function StatusBadge({ status, className = "" }) {
  const cls = STATUS_STYLES[status] || "bg-slate-100 text-slate-700 dark:bg-slate-500/15 dark:text-slate-300";
  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold ${cls} ${className}`}>
      <span className="w-1.5 h-1.5 rounded-full bg-current" />
      {status}
    </span>
  );
}
